<div [ngClass]="this.menuService.menuOptions['configuration'] ? 'active' : ''" class="database-menu">
  <div>
    <h1>Configuration</h1>
    <ul>
      <h4>App Configuration</h4>

      <app-menu-option
        [action]="this.openProjectManager.bind(this)"
        [label]="'Project Manager'">
      </app-menu-option>
<!--TODO-->
<!--      <app-menu-option-->
<!--        [action]="this.editProjectDetailsTrigger.bind(this)"-->
<!--        [label]="'Project Details'">-->
<!--      </app-menu-option>-->

      <app-menu-option *editable
        [action]="this.tabsService.openInterferenceTestTab.bind(tabsService)"
        [label]="'Interference Test'">
      </app-menu-option>
<!--      <h4>Interference Test</h4>-->
<!--      <app-menu-option-->
<!--        [action]="this.tabsService.gritOpenUniqueTab.bind(tabsService, TabsService.MANAGE_DEVICES)"-->
<!--        [label]="'Manage Devices'">-->
<!--      </app-menu-option>-->
<!--      <app-menu-option-->
<!--        [action]="this.tabsService.gritOpenUniqueTab.bind(tabsService, TabsService.MANAGE_RECEIVERS)"-->
<!--        [label]="'Manage Receivers'">-->
<!--      </app-menu-option>-->

      <h4>Others</h4>
      <!--<app-menu-option [selectOption]="this.openConfigurationManager">Configuration Manager</app-menu-option>-->
<!--      <app-menu-option-->
<!--        [action]="this.openFacility.bind(this)"-->
<!--        [label]="'Facility'">-->
<!--      </app-menu-option>-->
      <!--<app-menu-option [selectOption]="this.openDirectories">Directories</app-menu-option>-->
      <app-menu-option
        [action]="this.openTerrains.bind(this)"
        [label]="'Terrain'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openCalculation.bind(this)"
        [label]="'Calculation'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openRNAV.bind(this)"
        [label]="'RNAV'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openProcedure.bind(this)"
        [label]="'Procedure'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openDefaultAltitudes.bind(this)"
        [label]="'Default Altitudes'">
      </app-menu-option>
      <!--<app-menu-option [selectOption]="this.genericController.showMesssageModal('Log Altitudes')">Log Altitudes</app-menu-option>-->
      <!--<app-menu-option [selectOption]="this.openNetwork">Network</app-menu-option>-->
      <app-menu-option
        [action]="this.openDisplay.bind(this)"
        [label]="'Display'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openRCS.bind(this)"
        [label]="'RCS'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openLayers.bind(this)"
        [label]="'Layers'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openConfigurationColorSettings.bind(this)"
        [label]="'Color Settings'">
      </app-menu-option>
     <!--  <app-menu-option
        [action]="this.openChangeCumulativeCoverageColorGradient.bind(this)"
        [label]="'Color Gradient Cumulative Coverage'">
      </app-menu-option> -->
      <app-menu-option
        [action]="this.openAntennaModels.bind(this)"
        [label]="'Antenna Models'">
      </app-menu-option>
      <app-menu-option *ngIf="isAdmin$ | async"
        [action]="this.openContextualHelp.bind(this)"
        [label]="'Contextual Help'">
      </app-menu-option>

      <h4 *ngIf="isAdmin$ | async"> Users Informations</h4>

      <!--<app-menu-option
        [action]="this.openUserSpaceUser.bind(this)"
        [label]="'User Space'">
      </app-menu-option> -->
      <app-menu-option  *ngIf="isAdmin$ | async"
        [action]="this.openUserSpaceAdmin.bind(this)"
        [label]="'User Spaces Admin View'">
      </app-menu-option>


      <app-menu-option *ngIf="isAdmin$ | async"
        [action]="this.openUserManagement.bind(this)"
        [label]="'User Management'">
      </app-menu-option>
      <!-- <app-menu-option
        [action]="this.openUserProfile.bind(this)"
        [label]="'User Profile'">
      </app-menu-option> -->
    </ul>
  </div>
</div>
